import { IApplicationState } from '../../types/redux';

export const selectHasMetro = (state: IApplicationState): boolean => {
  return state.region.currentRegion.hasMetro;
};
